import { render, staticRenderFns } from "./InsKpiGrid.vue?vue&type=template&id=b6d14d9a"
import script from "./InsKpiGrid.vue?vue&type=script&lang=js"
export * from "./InsKpiGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports